import disableImageRightClick from "./disable-image-right-click";
import fadeIn from "./fade-in";
import gallery from "./gallery";
import loadMore from "./load-more";
import nav from "./nav";
import rail from "./rail";
import video from "./video";
import initMaps from "./init-maps";
import initAccordion from "./accordion";
import overviewParallax from "./overview-parallax";
import coursesLoadMore from "./courses-load-more";
import galleryLightbox from "./gallery-lightbox";
import testimonialsRotator from "./testimonials-rotator";
import cardsModal from "./cards-modal";
import cardsCarousel from "./cards-carousel";
import timelineSlider from "./timeline-slider";
import drawsFilter from "./draws-filter";

function initGoogleAnalytics() {
  const body = document.querySelector("body");
  const googleAnalyticsId = body && body.dataset
    ? body.dataset.googleAnalyticsId
    : null;
  if (!googleAnalyticsId) return;
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", googleAnalyticsId);
}

document.addEventListener("DOMContentLoaded", () => {
  initGoogleAnalytics();
  fadeIn();
  gallery();
  loadMore();
  nav();
  rail();
  video();
  disableImageRightClick();
  initMaps();
  initAccordion();
  overviewParallax();
  coursesLoadMore();
  galleryLightbox();
  testimonialsRotator();
  cardsModal();
  cardsCarousel();
  timelineSlider();
  drawsFilter();
});
